import { getPlatformType } from '../../components/utils/Helper';
import useWindowSize from './useWindowSize';

function useIsMobile() {
  const { size } = useWindowSize();
  const mobileThreshold = 640;
  const platformType = getPlatformType();
  const isMobilePlatform = platformType === 'mobile';
  return size.width <= mobileThreshold || isMobilePlatform;
}

export default useIsMobile;
